module.exports = __webpack_public_path__ + "static/media/MuhammadAfzalTanoli.b0f5da4a.jpg";